import { deserializeHtml } from '@udecode/plate-core';
import { Button } from 'components/atoms/Button';
import { last } from 'lodash';
import type { FC } from 'react';
import { CheckCircleIconOutline } from 'utils/icons';
import { RegenerateIconOutline } from 'utils/icons/figmaIcons';
import { convertTextNodesToElements } from '../EmailClient/utils';
import type { EditorRef } from '../TextEditor';
import { convertVariablesToHtml } from '../TextEditor/serializeHtml';
import { useAIChatContext } from './AIChat.context';

type AIChatMessageEmailActionsProps = {
  editorRef?: EditorRef;
  variablesData: Record<string, any>;
  onApprove: () => void;
};

const AIChatMessageEmailActions: FC<AIChatMessageEmailActionsProps> = ({
  editorRef,
  variablesData,
  onApprove,
}) => {
  const { handleRegenerateMessage, conversation } = useAIChatContext();

  const message = last(conversation?.messages);

  const onApproveEmailContent = () => {
    if (!editorRef?.current?.children) return;

    const nodes = deserializeHtml(editorRef.current, {
      element: convertVariablesToHtml(message?.content || '', variablesData),
    });

    editorRef.current.children = convertTextNodesToElements(nodes);
    editorRef.current.onChange();
    onApprove();
  };

  if (!message || message?.role === 'user') return null;

  return (
    <div className="flex flex-row space-x-2 !mt-1 self-end">
      <Button structure="text" onClick={() => onApproveEmailContent()}>
        <CheckCircleIconOutline className="w-4 h-4 text-primary-400" />
      </Button>
      <Button
        structure="text"
        onClick={() => handleRegenerateMessage(message._id)}
      >
        <RegenerateIconOutline className="w-4 h-4 text-primary-400" />
      </Button>
    </div>
  );
};

export default AIChatMessageEmailActions;
